import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from '../models/product';
import { Cancellation } from '../models/cancellation';
import { FrontError } from '../models/frontError';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private http: HttpClient,
  ) {
  }

  getProducts(modelCode: string, serialNumber: string, agentId: string, storename: string, ticketNo?: string): Observable<any> {
    const data = {
      recaptcha: true,
      modelCode: modelCode.trim(),
      serialNo: serialNumber.trim(),
      agentId,
      storename,
      ticketNo,
    };
    console.log('consumer/scplus/checkSerialNoValidation', data);
    return this.http.post<any>('consumer/scplus/checkSerialNoValidation', data, httpOptions);
  }

  getProductsWithSerialNumber(serialNumber: string, email: string): Observable<any> {
    const data = {
      email: email.trim(),
      serialNo: serialNumber.trim()
    };
    console.log('consumer/scplus/getContractInfo', data);
    return this.http.post<any>('consumer/scplus/getContractInfo', data, httpOptions);
  }

  getProductsWithPolicyNumber(policyNumber: string, email: string): Observable<any> {
    policyNumber.replace(/ /g, '');
    email.replace(/ /g, '');
    const data = {
      email: email.trim(),
      policyNo: policyNumber.trim()
    };
    console.log('consumer/scplus/getContractInfo', data);
    return this.http.post<any>('consumer/scplus/getContractInfo', data, httpOptions);
  }

  getTax(serialNumber: string, postalCode: string, country: string, product: Product): Observable<any> {
    const data = {
      postalCode,
      country: 'US',
      lineItem: [{
        modelCode: product.MODELCODE,
        serialNo: serialNumber,
        sku: product.SKU,
        quantity: 1,
        price: product.TECHNICIANID ? product.PRICE - 10 : product.PRICE,
        technicianId: product.TECHNICIANID,
      }]
    };
    console.log('consumer/scplus/getTax', data);
    return this.http.post<any>('consumer/scplus/getTax', data, httpOptions);
  }

  setOrder(data: any): Observable<any> {
    console.log('consumer/scplus/payment', data);
    return this.http.post<any>('consumer/scplus/payment', data, httpOptions);
  }

  setCancellation(cancellation: Cancellation): Observable<any> {
    console.log('consumer/scplus/cancel', cancellation);
    return this.http.post<any>('consumer/scplus/cancel', cancellation, httpOptions);
  }

  resend(cancellation: Cancellation): Observable<any> {
    console.log('consumer/scplus/resend_email', cancellation);
    return this.http.post<any>('consumer/scplus/resend_email', cancellation, httpOptions);
  }

  saveFrontError(frontError: FrontError): Observable<any> {
    console.log('consumer/scplus/saveFrontError', frontError);
    return this.http.post<any>('consumer/scplus/saveFrontError', frontError, httpOptions);
  }

  checkAmazonUser(data: any): Observable<any> {
    console.log('consumer/amazon/check-user', data);
    return this.http.post<any>('consumer/amazon/check-user', data, httpOptions);
  }
  checkAmazonUserCepos(data: any, endPoint): Observable<any> {
    console.log(endPoint, data);
    return this.http.post<any>('consumer/amazon/check-user-cepos', data, httpOptions);
  }
}
